<import-file [title]="'Import Document'" [isGeneric]="false" [documentType]="documentType.ContractDoc"
  [attachmentId]="attachmentId" [requiredColumns]="contractRequiredColumns"></import-file>